import React from 'react';
import { Link } from 'react-router-dom';
import './PublicFooter.css';

export default function PublicFooter() {
  return (
    <footer className="public-footer">
      <div className="public-footer__inner">
        <p className="public-footer__copy">
          © {new Date().getFullYear()} Inqlect Technologies Pvt Ltd. All rights reserved.
        </p>
        <div className="public-footer__links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="mailto:info@inqlect.com">info@inqlect.com</a>
        </div>
      </div>
    </footer>
  );
}
